import { GridRowSelectionModel } from "@mui/x-data-grid";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";

import { deleteListOfRequest, getTopTenRequestData } from "../../api/Home";
import { ITrRequest } from "../../interfaces/ITrRequest";
import {
  selectNewProfile,
  selectNewProfileRole,
} from "../../store/newProfile/selector";

interface Return {
  data: {
    listTrRequest: ITrRequest[];
    loadingActive: boolean;
  };
  method: {
    onGetTopTenListTrData(search?: string): void;
    onDeleteSelected(selectedRows: GridRowSelectionModel): void;
  };
}

export default function useViewModel(): Return {
  const [listTrRequest, setListTrRequest] = useState<ITrRequest[]>([]);
  const [loadingActive, setLoadingActive] = useState(true);

  const profile = useSelector(selectNewProfile);
  const profileRole = useSelector(selectNewProfileRole);

  const onGetTopTenListTrData = useCallback(
    async (search?: string) => {
      setLoadingActive(true);
      await getTopTenRequestData(profileRole.roleId, profile.BinusianId, search)
        .then((res) => setListTrRequest(res))
        .then(() => {
          setLoadingActive(false);
        })
        .catch((error) => console.log("Error fetching data:", error));
    },
    [getTopTenRequestData]
  );

  const onDeleteSelected = useCallback(
    async (selectedRows: GridRowSelectionModel) => {
      setLoadingActive(true);
      await deleteListOfRequest(selectedRows as string[], profile.BinusianId)
        .then(() => onGetTopTenListTrData())
        .then(() => {
          setLoadingActive(false);
        })
        .catch((error) => console.log("Error fetching data:", error));
    },
    [deleteListOfRequest]
  );

  return {
    data: {
      listTrRequest,
      loadingActive,
    },
    method: {
      onGetTopTenListTrData,
      onDeleteSelected,
    },
  };
}
